import React, { ReactElement, ButtonHTMLAttributes } from 'react';
import classes from './Button.module.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: string;
  variant?: string;
  leftIcon?: ReactElement;
  rightIcon?: ReactElement;
  color?: string;
}

export const Button = ({
  children,
  variant = '',
  leftIcon,
  rightIcon,
  size,
  className = '',
  color = '',
  ...rest
}: ButtonProps) => {
  return (
    <button
      data-variant={variant}
      data-size={size}
      data-color={color}
      type="button"
      {...rest}
      className={`${classes.root} ${className}`}
    >
      <div className={classes.inner}>
        {leftIcon && <span className={classes.leftIcon}>{leftIcon}</span>}
        <span className={classes.text}>{children}</span>
        {rightIcon && <span className={classes.rightIcon}>{rightIcon}</span>}
      </div>
    </button>
  );
};
